// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

const SET_FUNDRAISE_FORM_FIELD = 'SET_FUNDRAISE_FORM_FIELD';

const VALIDATE_PHONE_NUMBER_FUNDRAISE = 'VALIDATE_PHONE_NUMBER_FUNDRAISE';
const VALIDATE_BANK_ACCOUNT = 'VALIDATE_BANK_ACCOUNT';
const SET_ERROR = 'SET_ERROR';
const RESET_ERROR = 'RESET_ERROR';

const SET_IS_BUTTON_PRESSED = 'SET_IS_BUTTON_PRESSED';

const GET_FUNDRAISE_PAGE_DATA = 'GET_FUNDRAISE_PAGE_DATA';
const GET_FUNDRAISE_PAGE_DATA_SUCCESS = 'GET_FUNDRAISE_PAGE_DATA_SUCCESS';

const REGISTER_CHARITY = 'REGISTER_CHARITY';
const REGISTER_CHARITY_SUCCESS = 'REGISTER_CHARITY_SUCCESS';

const RESET_STATUS = 'RESET_STATUS';

export {
  SET_FUNDRAISE_FORM_FIELD,

  VALIDATE_PHONE_NUMBER_FUNDRAISE,
  VALIDATE_BANK_ACCOUNT,
  SET_ERROR,
  RESET_ERROR,

  SET_IS_BUTTON_PRESSED,

  GET_FUNDRAISE_PAGE_DATA,
  GET_FUNDRAISE_PAGE_DATA_SUCCESS,

  REGISTER_CHARITY,
  REGISTER_CHARITY_SUCCESS,

  RESET_STATUS,
};
